type CreateLink = (fileId: number) => Promise<{ url: string }>;

// Anchor clicks instead of window.open: opening after an await trips popup
// blockers (and does so for every call after the first in a loop).
export async function downloadViaAnchor(createLink: CreateLink, fileId: number, fileName?: string) {
  const link = await createLink(fileId);
  const anchor = document.createElement('a');
  anchor.href = link.url;
  anchor.download = fileName || 'download';
  anchor.target = '_blank';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
